import { helper } from "@ember/component/helper";
export function datepickerFormat(params: [Date, string]) {
  const date = params[0];
  const format = params[1];
  switch (format) {
    case "datetime":
      return datetimeFormat(date);
    default:
      return dateFormat(date);
  }
}

export function datetimeFormat(date: Date) {
  if (!date) return "";
  let dateString = Intl.DateTimeFormat("fr-fr", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
  dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
  return dateString;
}

export function dateFormat(date: Date) {
  if (!date) return "";
  return Intl.DateTimeFormat("fr-fr", {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  }).format(date);
}

export function dateLongFormat(date: Date) {
  if (!date) return "";
  let dateString = Intl.DateTimeFormat("fr-fr", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric"
  }).format(date);
  dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
  return dateString;
}

export function dateMonthYearFormat(date: Date) {
  if (!date) return "";
  let dateString = Intl.DateTimeFormat("fr-fr", {
    month: "numeric",
    year: "numeric"
  }).format(date);
  dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
  return dateString;
}

export function dateYearFormat(date: Date) {
  if (!date) return "";
  let dateString = Intl.DateTimeFormat("fr-fr", {
    year: "numeric"
  }).format(date);
  dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
  return dateString;
}

export default helper(datepickerFormat);
